var map = {
	"./audition.svg": 1916,
	"./avi.svg": 1917,
	"./doc.svg": 1918,
	"./exe.svg": 1919,
	"./file.svg": 1159,
	"./jpg.svg": 1920,
	"./mp3.svg": 1921,
	"./mp4.svg": 1922,
	"./pdf.svg": 1923,
	"./ppt.svg": 1924,
	"./rtf.svg": 1925,
	"./txt.svg": 1926,
	"./xls.svg": 1927,
	"./zip.svg": 1928
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1915;


//////////////////
// WEBPACK FOOTER
// ./src/components/vue-beautiful-chat/src/assets/file_icons ^\.\/.*\.svg$
// module id = 1915
// module chunks = 116